import { createStructuredSelector } from "reselect";
import {
  UPLOAD_PATENT_SET,
  UPLOAD_PATENT_SET_SUCCESS,
  UPLOAD_PATENT_SET_ERROR,
  UPLOAD_PATENT_RESET
} from "../actions";

export const NAME = "upload_patent";

const upload_patent = (state) => state[NAME];

export const uploadPatentSet = (file) => (
  {
    type: UPLOAD_PATENT_SET,
    payload: { file },
  }
);

export const uploadPatentSetSuccess = (items) => ({
  type: UPLOAD_PATENT_SET_SUCCESS,
  payload: items,
});

export const uploadPatentSetError = (error) => ({
  type: UPLOAD_PATENT_SET_ERROR,
  payload: error,
});

export const uploadPatentReset= () => ({
  type: UPLOAD_PATENT_RESET
});

export const UploadPatentSelector = createStructuredSelector({
  upload_patent,
});
